<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
        ></dx-grid>
        <v-dialog persistent v-model="assignDialog" fullscreen hide-overlay>
            <v-card class="fax-assign-dialog">
                <v-toolbar dark color="success">
                    <v-toolbar-title class="white--text">Assign Fax</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeAssignDialog()">
                        Cancel
                    </v-btn>
                    <v-btn
                        :loading="processing"
                        color="default"
                        dark
                        class="ml-2"
                        :disabled="!newAccountID"
                        @click="saveAssign()"
                    >
                        Save
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-3">
                    <v-layout row wrap>
                        <v-flex xs12 md8 class="pr-3">
                            <fax-preview
                                v-if="assignDialog && rowClicked.id"
                                :key="rowClicked.id"
                                :row="rowClicked"
                                :hideAssign="true"
                            ></fax-preview>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-card class="pa-3">
                                <div class="subheading mb-2">
                                    Find and assign account
                                </div>
                                <assign-account-lookup
                                    ref="assignLookup"
                                    v-model="newAccountID"
                                    @selected="onAccountSelected"
                                ></assign-account-lookup>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    provide() {
        return {
            openAssignFax: (row) => this.openAssignDialog(row),
        };
    },
    data: () => ({
        title: "Faxes",
        url: "faxes?includeAssigned=false",
        actions: [],
        user: "",
        processing: false,
        assignDialog: false,
        rowClicked: {},
        account: {},
        newAccountID: "",
        columns: [
            {
                field: "hasAttachment",
                label: "Att.",
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: true,
                allowHeaderFiltering: true,
                allowHiding: true,
                allowSearch: false,
                cssClass: "width-25",
                icon: (value) => {
                    return value ? "mdi-paperclip" : "";
                },
                iconColor: () => {
                    return "#5c6bc0";
                },
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "hname",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountID",
                link: "Account View",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "From",
                field: "from",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "To",
                field: "to",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Subject",
                field: "subject",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "File",
                field: "fileName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Assigned By",
                field: "userName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Assigned Date",
                field: "assignedDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.user = this.$store.state.authentication.user;

        this.columns.find((c) => c.field == "accountID").showLink = (row) =>
            !!row.accountID;

        this.actions.push({
            text: "Show Assigned",
            type: "switch",
            action: this.onShowAssignedChanged,
        });
    },
    methods: {
        onShowAssignedChanged(value) {
            this.url = value
                ? "faxes?includeAssigned=true"
                : "faxes?includeAssigned=false";

            this.$refs.grid.reloadDataSource(this.url);
        },
        onRowClicked(row) {
            this.openAssignDialog(row);
        },
        openAssignDialog(row) {
            this.rowClicked = row;
            this.account = {};
            this.newAccountID = row.accountID || "";
            this.assignDialog = true;

            if (this.$refs.assignLookup && this.$refs.assignLookup.clear) {
                this.$refs.assignLookup.clear();
            }
        },
        closeAssignDialog() {
            this.account = {};
            this.newAccountID = "";
            this.assignDialog = false;
        },
        onAccountSelected(account) {
            this.account = account || {};
            this.newAccountID = account && account.accountID ? account.accountID : "";
        },
        async saveAssign() {
            if (!this.newAccountID) {
                return;
            }

            this.processing = true;

            try {
                await this.$http.post("api/faxes/assignAccount", {
                    faxID: this.rowClicked.id,
                    accountID: this.newAccountID,
                    user: this.user,
                });
            } catch (e) {
                this.processing = false;
                return;
            }

            this.processing = false;
            this.closeAssignDialog();
            this.$refs.grid.reloadGrid();

            this.$notify({
                group: "notification",
                text: "Fax assigned",
                type: "success",
            });
        },
    },
};
</script>
<style></style>
